import * as React from "react";
import { IconProps } from "../types";

const CircleDottedCheckmarkIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M9.5 1.75C13.504 1.75 16.75 4.996 16.75 9C16.75 13.004 13.504 16.25 9.5 16.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 9.25L8.5 11.75L12.75 6.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.373 14.877C4.78721 14.877 5.123 14.5412 5.123 14.127C5.123 13.7128 4.78721 13.377 4.373 13.377C3.95879 13.377 3.623 13.7128 3.623 14.127C3.623 14.5412 3.95879 14.877 4.373 14.877Z"
          fill={color}
        />
        <path
          d="M2.25 9.75C2.66421 9.75 3 9.41421 3 9C3 8.58579 2.66421 8.25 2.25 8.25C1.83579 8.25 1.5 8.58579 1.5 9C1.5 9.41421 1.83579 9.75 2.25 9.75Z"
          fill={color}
        />
        <path
          d="M4.373 4.623C4.78721 4.623 5.123 4.28721 5.123 3.873C5.123 3.45879 4.78721 3.123 4.373 3.123C3.95879 3.123 3.623 3.45879 3.623 3.873C3.623 4.28721 3.95879 4.623 4.373 4.623Z"
          fill={color}
        />
        <path
          d="M6.726 16.448C7.14021 16.448 7.476 16.1122 7.476 15.698C7.476 15.2838 7.14021 14.948 6.726 14.948C6.31178 14.948 5.976 15.2838 5.976 15.698C5.976 16.1122 6.31178 16.448 6.726 16.448Z"
          fill={color}
        />
        <path
          d="M2.802 12.524C3.21622 12.524 3.552 12.1882 3.552 11.774C3.552 11.3598 3.21622 11.024 2.802 11.024C2.38779 11.024 2.052 11.3598 2.052 11.774C2.052 12.1882 2.38779 12.524 2.802 12.524Z"
          fill={color}
        />
        <path
          d="M2.802 6.976C3.21622 6.976 3.552 6.64021 3.552 6.226C3.552 5.81179 3.21622 5.476 2.802 5.476C2.38779 5.476 2.052 5.81179 2.052 6.226C2.052 6.64021 2.38779 6.976 2.802 6.976Z"
          fill={color}
        />
        <path
          d="M6.726 3.052C7.14021 3.052 7.476 2.71621 7.476 2.302C7.476 1.88779 7.14021 1.552 6.726 1.552C6.31178 1.552 5.976 1.88779 5.976 2.302C5.976 2.71621 6.31178 3.052 6.726 3.052Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default CircleDottedCheckmarkIcon;
